import { NgModule } from 'ng-metadata/core';
import { CollectionBulkActionComponent } from './collection-bulk-action-header/collection-bulk-action.component';
import { CollectionHeaderComponent } from './collection-header/collection-header.component';
import { CollectionSearchComponent } from './collection-search/collection-search.component';

/**
 * @ngdoc module
 * @name mw.components.collection
 * @description
 *
 * Collection
 */
@NgModule({
    declarations: [ CollectionBulkActionComponent, CollectionHeaderComponent, CollectionSearchComponent ]
})
export class CollectionModule {}



// WEBPACK FOOTER //
// ./src/lib/components/collection/collection.module.ts